import PosJournalList from "../component/PosJournalList";
import React from "react";

const PosJournalListContainer = () => (<PosJournalList />)

export default PosJournalListContainer;